import React, { type FunctionComponent } from 'react'
import { Text } from '@retailer-platform/shared-components'
import { MerchandisingFormSection } from 'domains/merchandising/components/form-section/MerchandisingFormSection'
import { useDashMessages } from 'intl/intl.hooks'

// TODO - reuse this type
interface Props {
  placementLocation: string[]
}

export const HeroBannerDetailsLocation: FunctionComponent<Props> = ({ placementLocation }) => {
  const messages = useDashMessages({
    emptyValue: 'merchandising.hero-banners.field.empty.value',
    locationLabel: 'merchandising.hero-banners.section.location.field.location.label',
  })

  const locations = placementLocation.join(', ')

  return (
    <MerchandisingFormSection titleId="merchandising.hero-banners.section.location.title">
      <Text weight="semibold">{messages.locationLabel}</Text>
      <Text size="medium">{locations || messages.emptyValue}</Text>
    </MerchandisingFormSection>
  )
}
